{
  "es": {
    "customer": {
      "actions": {
        "addCompany": "Añadir organización",
        "addCustomer": "Añadir cliente",
        "addSecondaryContact": "Añadir contacto secundario",
        "add_email_address": "Añadir correo",
        "bulk_import": "Importar clientes",
        "cancel": "Deshacer",
        "changeProfilePicture": "Cambiar foto de perfil",
        "createNewCustomer": "Añadir nuevo cliente...",
        "goToCustomerProfile": "Ir a la página de contacto del cliente",
        "new": "Cliente",
        "profilePictureFormat": "La imagen debe medir al menos <strong>300x300px</strong>",
        "removeCompany": "Quitar detalles de la organización",
        "removeCustomer": "Quitar este cliente",
        "removeSecondaryContact": "Eliminar contacto secundario",
        "save": "Guardar",
        "searchCustomer": "Buscar cliente",
        "submit": "Guardar",
        "uploadProfilePicture": "Subir una foto de perfil"
      },
      "attributes": {
        "address": "Dirección",
        "birth_date": "Fecha de nacimiento",
        "categories": {
          "enduser": "Comprador ocupante",
          "investor": "Inversor"
        },
        "category": "Tipo de cliente",
        "company_name": "Nombre de la organización",
        "company_vat": "Número de IVA",
        "email_address": "Correo electrónico",
        "email_address_secondary": "Correo electrónico del contacto secundario",
        "email_notifications_interval": {
          "daily": "Una vez al día (alrededor del mediodía)",
          "hourly": "Cada hora",
          "twice_daily": "Dos veces al día (mediodía/noche)",
          "weekly": "Una vez a la semana (lunes al mediodía)"
        },
        "first_name": "Nombre",
        "iban": "IBAN",
        "internal_note": "Nota interna",
        "language": "Idioma",
        "last_name": "Apellidos",
        "phone_landline": "Número de teléfono fijo",
        "phone_mobile": "Número de móvil",
        "status": "Estado"
      },
      "import": {
        "fill_customer_info": "Completa la plantilla con la información del cliente",
        "fix_file_upload_customer": "Corrige los problemas y vuelve a subir el archivo.</br>Los clientes existentes no se eliminarán, pero se actualizarán si algo ha cambiado en el archivo para ese cliente desde la última subida."
      },
      "labels": {
        "customerAddedState": "<b>Aún no invitado.</b> Se enviará un correo de invitación en cuanto {name} tenga acceso a una unidad asignada.",
        "customerAddedStateNoEmailAddress": "<b>No se conoce ningún correo.</b> Se necesita un correo para dar a {name} acceso a una unidad asignada.",
        "display": "Visualización",
        "hasAccessToUnit": "Tiene acceso en línea a la unidad",
        "information": "Tu información",
        "noCustomersYet": "Aún no hay clientes en la plataforma",
        "noEmailAddress": "Sin correo",
        "noProject": "Aún no hay ningún proyecto asignado",
        "noUnits": "Aún no hay unidades asignadas",
        "notSharedWithCustomer": "No visible para el cliente",
        "notificationDisclaimer": "Cuando haya contenido nuevo disponible para ti, recibirás una notificación. Si aún no has leído estas notificaciones en la plataforma, se agruparán y se enviarán por correo. A continuación, puedes desactivar las notificaciones sobre ciertos temas y aumentar o reducir la frecuencia de los correos.",
        "onPlatform": "En la plataforma",
        "otherSettings": "Otros ajustes",
        "password": "Contraseña",
        "primaryContact": "Tus datos",
        "project": "Proyecto",
        "secondaryContact": "Contacto secundario",
        "sharedWithCustomer": "Visible para el cliente",
        "sorting": "Orden",
        "units": "Unidades",
        "viaEmail": "Por correo"
      },
      "messages": {
        "integrationUpdateInformation": "Contáctanos si deseas actualizar cierta información.",
        "userlessProfileNotice": "Este perfil no tiene ningún correo vinculado."
      },
      "toasts": {
        "birthday": "¡Feliz cumpleaños, {first_name}!",
        "create": "Cliente añadido",
        "delete": "Cliente eliminado",
        "update": "Cliente actualizado",
        "upload": "Todos los clientes se han importado correctamente"
      },
      "validation": {
        "needFirstName": "El nombre es obligatorio",
        "needFirstNameSecondary": "El nombre del contacto secundario es obligatorio",
        "needLastName": "Los apellidos son obligatorios",
        "needLastNameSecondary": "Los apellidos del contacto secundario son obligatorios"
      }
    }
  }
}
